import React from 'react';

export const Featurebase: React.FC = () => {
  return <iframe src="https://concreit.featurebase.app" height="600" width="100%" id="featurebase-frame"></iframe>;
};
